import styled from 'styled-components';

import { PaletteColor, GetSCProps } from '@utils/types';

export type RadioGroupStyleProps = GetSCProps<
  'color',
  {
    selectedOptionColor: PaletteColor;
    direction?: 'row' | 'column';
  }
>;

export const RadioWrapper = styled.div<{
  direction?: string;
  disabled?: boolean;
}>`
  display: flex;
  flex-direction: ${(p) => p.direction};
  gap: 20px;
  opacity: ${({ disabled }) => (disabled ? '0.4' : '1')};
`;
